var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-remover-cx",attrs:{"fab":"","color":"error","x-small":!_vm.isMobile(),"small":_vm.isMobile()},on:{"click":function($event){$event.stopPropagation();return _vm.removerProdutoCaixa()}}},[_c('v-icon',[_vm._v("mdi-trash-can-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }